"use strict";
exports.__esModule = true;
var index_1 = require("./index");
var Adapter = /** @class */ (function () {
    function Adapter() {
    }
    Adapter.shouldConvertToNumber = function (value) {
        if (typeof value === 'number') {
            return value;
        }
        else if (typeof value === 'string') {
            var converted = parseInt(value, 10);
            return isNaN(converted) ? null : converted;
        }
        return null;
    };
    Adapter.stringToArray = function (data) {
        var _a = index_1.splitMoneyString(data), amount = _a[0], currency = _a[1], decimals = _a[2];
        return [amount, currency, decimals];
    };
    Adapter.objectToArray = function (data) {
        return [data.amount, data.currency, data.decimals];
    };
    Adapter.params = function (data) {
        var _a = typeof data === 'string'
            ? Adapter.stringToArray(data)
            : Adapter.objectToArray(data), amount = _a[0], currency = _a[1], decimals = _a[2];
        return [Adapter.shouldConvertToNumber(amount), currency, Adapter.shouldConvertToNumber(decimals)];
    };
    return Adapter;
}());
exports.Adapter = Adapter;
//# sourceMappingURL=money.adapter.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@qwentes/models/lib/packages/money/money.adapter.js
// module id = 254
// module chunks = 0